import { __decorate, __metadata } from "tslib";
// NPM
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import _ from "lodash";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
// SYSTEM1
import { getTenantId } from "@/store/helper";
import { IPAReviewSearchData } from "../models/paReview/paReviewSearchData";
import { PAReviewItemModel } from "../models/paReview/paReviewItemDTO";
import { PAReviewItemDetailModel } from "../models/paReview/paReviewItemDetailDTO";
import { PAReviewAnswerItemModel } from "../models/paReview/paReviewAnswerItemDTO";
import { IPAReviewCommentItemDTO, PAReviewCommentItemModel } from "../models/paReview/paReviewCommentItemDTO";
import { IPAReviewRejectionReasonDTO } from "../models/paReview/paReviewRejectionReasonDTO";
import { GuidItemModel, IGuidItem } from "../models/shared/guidItem";
import { IClientInteractionDetailsDTO } from "../models/paReview/clientInteractionDetailsDTO";
import { IPACycleEmployeeReviewOverViewExecutorDTO } from "../models/paReview/paCycleEmployeeReviewOverViewExecutorDTO";
import { IClientContactAssignmentDTO } from "../models/paReview/clientContactAssignmentDTO";
import { PACycleRequestModel } from "../models/cycle/paCycleRequestDTO";
import { PAReviewNudgeModel } from "../models/paReview/paReviewNudgeDTO";
import { PACycleLegendsModel } from "../models/cycle/paCycleLegendsDTO";
import { PAReviewMeetingModel } from "../models/paReview/paReviewMeetingDTO";
import { PAReviewScheduleMeetingModel } from "../models/paReview/paReviewScheduleMeeting";
import { PAReviewMeetingActionItemModel } from "../models/paReview/paReviewMeetingActionItem";
import { PAReviewMeetingParticipantsModel } from "../models/paReview/paReviewMeetingParticipantsDTO";
let PAReviewsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
    let PAReviewsModule = class PAReviewsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "paReview";
            this.reviews = [];
            this.totalCount = 0;
            this.isClientInterfacer = false;
            this.isReportingToManager = false;
            this.reviewDetail = null;
            this.stepTabs = [];
            this.yearList = [];
            this.teams = [];
            this.openedByClient = false;
            this.clientReview = null;
            this.pdfData = null;
            this.reviewId = null;
            this.clientInteractionDetails = null;
            this.paCycleExecutor = null;
            this.cycleSummary = null;
            this.clientAssignmentId = "";
            this.operatingStepId = "";
            this.gridParams = null;
            this.showActionableItems = false;
            this.clientNudgeHistory = [];
            this.paAdminNudgeHistory = [];
            this.legends = [];
            this.paCycleReviewsStatus = [];
            this.paReviewMeeting = null;
            this.isMeetingCreated = false;
            this.reviewMeetingParticipants = [];
            this.paReviewMeetingDetail = null;
            this.isGoogleCalendarSynced = false;
        }
        async GetReviewStepTabs() {
            var url = `${getTenantId()}/${this.apiNode}/getReviewStepTabs`;
            let { data } = await service.get(url);
            if (data) {
                this.SetStepTabs(data.reviewTabItems);
                return data.reviewTabItems;
            }
        }
        SetStepTabs(stepTabs) {
            this.stepTabs = stepTabs;
        }
        async GetReviews(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetReviews(plainToClass(PAReviewItemModel, data.reviews));
                this.SetTotalCount(data.totalCount);
                return data;
            }
        }
        async GetCycleSummary(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/cycleSummary?cycleId=${payLoad.cycleId}&stepId=${payLoad.stepId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCycleReviewsStatus(plainToClass(GuidItemModel, data.paCycleReviewsStatus));
                return data;
            }
        }
        async GetReviewCycles(searchData) {
            var url = `${getTenantId()}/${this.apiNode}/cycles`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.SetReviews(plainToClass(PAReviewItemModel, data.reviews));
                this.SetTeams(plainToClass(GuidItemModel, data.teams));
                this.SetYearList(plainToClass(GuidItemModel, data.yearList));
                this.SetTotalCount(data.totalCount);
                this.SetIsClientInterfacer(data.isClientInterfacer);
                this.SetIsReportingToManager(data.isReportingToManager);
                this.SetLegends(plainToClass(PACycleLegendsModel, data.legends));
                return data;
            }
        }
        SetCycleReviewsStatus(paCycleReviewsStatus) {
            this.paCycleReviewsStatus = paCycleReviewsStatus;
        }
        SetLegends(legends) {
            this.legends = legends;
        }
        SetReviews(reviews) {
            this.reviews = reviews;
        }
        SetTeams(teams) {
            this.teams = teams;
        }
        SetYearList(yearList) {
            this.yearList = yearList;
        }
        SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        async GetReviewDetailById(PayLoad) {
            var url = `${getTenantId()}/${this.apiNode}/getReview?reviewId=${PayLoad.reviewId}&stepId=${PayLoad.stepId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetReviewDetail(plainToClass(PAReviewItemDetailModel, data.reviewDetail));
                return data;
            }
        }
        async GetReviewDetailByIdForDisplay(PayLoad) {
            var url = `${getTenantId()}/${this.apiNode}/getReviewForDisplay?reviewId=${PayLoad.reviewId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetReviewDetail(plainToClass(PAReviewItemDetailModel, data.reviewDetail));
                return data;
            }
        }
        async GetReviewDetailByIdForClient(PayLoad) {
            var url = `ClientReview/getClientReview?tenantId=${getTenantId()}&reviewId=${PayLoad.reviewId}&stepId=${PayLoad.stepId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetReviewDetail(plainToClass(PAReviewItemDetailModel, data.reviewDetail));
                return data;
            }
        }
        SetReviewDetail(reviewDetail) {
            this.reviewDetail = reviewDetail;
        }
        async SaveReviewAnswers(qnaAnswer) {
            if (this.openedByClient) {
                var url = `ClientReview/saveClientAnswer/${getTenantId()}`;
            }
            else {
                var url = `${getTenantId()}/${this.apiNode}/saveAnswer`;
            }
            let { data } = await service.post(url, qnaAnswer);
            this.SetAnswerText(qnaAnswer);
            return data;
        }
        SetAnswerText(qnaAnswer) {
            const result = _.flatMap(this.reviewDetail?.reviewFormDetails, (x) => x.questionAndAnswerItems).find((x) => x.id == qnaAnswer.id);
            if (result) {
                result.answerText = qnaAnswer.answerText;
                result.id = qnaAnswer.id;
            }
        }
        async SaveReviewComment(reviewComment) {
            if (this.openedByClient) {
                var url = `ClientReview/saveClientComment/${getTenantId()}`;
            }
            else {
                var url = `${getTenantId()}/${this.apiNode}/saveComment`;
            }
            let { data } = await service.post(url, reviewComment);
            if (data) {
                if (this.openedByClient) {
                    this.setReviewClientComment(data.paReviewClientCommentItem);
                }
                else {
                    this.setReviewComment(data.paReviewCommentItem);
                }
            }
            return data;
        }
        async DeleteReviewComment(commentId) {
            if (this.openedByClient) {
                var url = `ClientReview/deleteClientComment/${getTenantId()}/` + commentId;
            }
            else {
                var url = `${getTenantId()}/${this.apiNode}/delete/` + commentId;
            }
            let { data } = await service.delete(url);
            return data;
        }
        setReviewComment(paReviewCommentItem) {
            const answers = _.flatMap(this.reviewDetail?.reviewFormDetails, (x) => x.questionAndAnswerItems);
            const ans = answers.find((y) => y.id == paReviewCommentItem.paCycleReviewAnswerId);
            if (ans.commentItems.findIndex((z) => z.id == paReviewCommentItem.id) == -1) {
                ans.commentItems.push(paReviewCommentItem);
            }
        }
        setReviewClientComment(paReviewClientCommentItem) {
            const answers = _.flatMap(this.reviewDetail?.reviewFormDetails, (x) => x.questionAndAnswerItems);
            const ans = answers.find((y) => y.id == paReviewClientCommentItem.paCycleReviewAnswerId);
            if (ans.clientCommentItems.findIndex((z) => z.id == paReviewClientCommentItem.id) === -1) {
                ans.clientCommentItems.push(paReviewClientCommentItem);
            }
        }
        async SubmitReview(reviewId) {
            if (this.openedByClient) {
                var url = `ClientReview/clientPromote/${getTenantId()}/${reviewId}?clientContactId=${this.clientReview.clientContactId}`;
            }
            else {
                var url = `${getTenantId()}/${this.apiNode}/promote/` + reviewId;
            }
            let { data } = await service.get(url);
            return data;
        }
        async DeliverReview({ reviewId, deliverToAll }) {
            var url = `${getTenantId()}/${this.apiNode}/deliver/${reviewId}?deliverToAll=${deliverToAll}`;
            let { data } = await service.get(url);
            return data;
        }
        async RejectReview(reject) {
            var url = `${getTenantId()}/${this.apiNode}/reject-review`;
            let { data } = await service.post(url, reject);
            return data;
        }
        async ClientInteractionDetails({ cycleId, stepId }) {
            var url = `${getTenantId()}/${this.apiNode}/clientInteraction?cycleId=${cycleId}&stepId=${stepId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetClientInteractionDetails(data.clientInteractionDetails);
                return data;
            }
        }
        async GetReviewExecutorDetails({ cycleId, operatingStepId }) {
            var url = `${getTenantId()}/${this.apiNode}/review-executor?operatingStepId=${operatingStepId}&cycleId=${cycleId}`;
            // const reviewIds = this.reviews.find((x) => x.cycleId == cycleId).reviewees.map((x) => x.reviewId);
            let { data } = await service.post(url);
            if (data) {
                this.SetReviewExecutorDetails(data.paCycleExecutor);
                return data;
            }
        }
        SetClientInteractionDetails(details) {
            this.clientInteractionDetails = details;
        }
        SetReviewExecutorDetails(paCycleExecutor) {
            this.paCycleExecutor = paCycleExecutor;
        }
        async GetCycleReviewDetailsForClient({ tenantId, clientAssignmentId }) {
            var url = `ClientReview?tenantId=${tenantId}&clientAssignmentId=${clientAssignmentId}`;
            let { data } = await service.get(url);
            if (data) {
                this.setCycleReviewDetailsForClient(data.paCycleReviewClient);
            }
            return data;
        }
        setCycleReviewDetailsForClient(paCycleReviewClient) {
            this.clientReview = paCycleReviewClient;
        }
        async SaveClientAssignments(payload) {
            var url = `${getTenantId()}/${this.apiNode}/clientAssignments`;
            let { data } = await service.post(url, payload);
            return data;
        }
        async ClientNudgeEmail(assignment) {
            var url = `${getTenantId()}/${this.apiNode}/clientNudgeEmail`;
            let { data } = await service.post(url, assignment);
            return data;
        }
        async GeneratePAReviewPDF(reviewId) {
            if (this.openedByClient) {
                var url = `ClientReview/reviewPDF/${getTenantId()}/` + reviewId;
            }
            else {
                var url = `${getTenantId()}/${this.apiNode}/reviewPDF/` + reviewId;
            }
            let { data } = await service.get(url, { responseType: "blob" });
            if (data) {
                this.setReviewId(reviewId);
                this.PdfblobData(data);
            }
            return data;
        }
        async UpdateAutoNudgeForClientContact(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/updateClientAutoNudge`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                return data;
            }
        }
        async GettingNudgeHistory(assignmentId) {
            var url = `${getTenantId()}/${this.apiNode}/clientNudgeHistory/` + assignmentId;
            let { data } = await service.get(url);
            if (data) {
                this.SetClientNudgeHistory(plainToClass(GuidItemModel, data.clientNudgeHistory));
                return data;
            }
        }
        async GettingPAAdminNudgeHistory(reviewId) {
            var url = `${getTenantId()}/${this.apiNode}/adminNudgeHistory/` + reviewId;
            let { data } = await service.get(url);
            if (data) {
                this.SetPAadminNudgeHistory(plainToClass(PAReviewNudgeModel, data.paAdminNudgeHistory));
                return data;
            }
        }
        async GetReviewMeeting(reviewId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/defaults?reviewId=${reviewId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetGoogleCalendar(data.isGoogleCalendarSynced);
                this.SetMeetingCreated(data.isMeetingCreated);
                this.SetReviewMeetingDefaults(plainToClass(PAReviewMeetingParticipantsModel, data.reviewMeetingParticipants));
                return data;
            }
        }
        async saveMeeting(reviewMeeting) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/add`;
            let { data } = await service.post(url, reviewMeeting);
            if (data) {
                return data;
            }
        }
        async GetReviewMeetingDetails(reviewId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/details?reviewId=${reviewId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetReviewMeeting(plainToClass(PAReviewMeetingModel, data.paReviewMeetingDetail));
                return data;
            }
        }
        async addActionItem(actionItem) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/action/add`;
            let { data } = await service.post(url, actionItem);
            if (data) {
                this.AppendActionItem(plainToClass(PAReviewMeetingActionItemModel, data.reviewMeetingActionItem));
                return data;
            }
        }
        async updateActionItem(actionItem) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/action/edit`;
            let { data } = await service.put(url, actionItem);
            if (data) {
                this.AppendActionItem(plainToClass(PAReviewMeetingActionItemModel, data.reviewMeetingActionItem));
                return data;
            }
        }
        async StartReviewMeeting(meetingId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/start?meetingId=${meetingId}`;
            let { data } = await service.put(url);
            if (data) {
                this.SetMeetingStarted(data);
                return data;
            }
        }
        async EndReviewMeeting(meetingId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/end?meetingId=${meetingId}`;
            let { data } = await service.put(url);
            if (data) {
                this.SetMeetingEnded(data);
                return data;
            }
        }
        async closeReviewMeeting(meetingId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/close?meetingId=${meetingId}`;
            let { data } = await service.put(url);
            if (data) {
                this.SetMeetingClosed();
                return data;
            }
        }
        async deleteReviewMeeting(meetingId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/delete?meetingId=${meetingId}`;
            let { data } = await service.delete(url);
            if (data) {
                this.ClearReviewMeeting();
                return data;
            }
        }
        async editMeetingDetailById(meetingId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/edit?meetingId=${meetingId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetMeetingDetail(plainToClass(PAReviewScheduleMeetingModel, data.paReviewMeetingDetail));
                return data;
            }
        }
        async updateMeeting(reviewMeeting) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/update`;
            let { data } = await service.post(url, reviewMeeting);
            if (data) {
                return data;
            }
        }
        async completeActionItem(payload) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/action/complete?actionItemId=${payload.actionItemId}`;
            let { data } = await service.put(url);
            if (data) {
                if (payload.needUpdate) {
                    this.CompleteActionItem(payload.actionItemId);
                }
                return data;
            }
        }
        async deleteActionItem(actionItemId) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/action/delete?actionItemId=${actionItemId}`;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveActionItem(actionItemId);
                return data;
            }
        }
        async upsertNotes(notes) {
            var url = `${getTenantId()}/${this.apiNode}/meeting/notes/save`;
            let { data } = await service.post(url, notes);
            if (data) {
                this.UpdateNotes(plainToClass(GuidItemModel, data.paReviewMeetingNotes));
                return data;
            }
        }
        UpdateNotes(notes) {
            if (this.paReviewMeeting.id === notes.id) {
                this.paReviewMeeting.reviewMeetingNotes = notes.value;
            }
        }
        CompleteActionItem(actionItemId) {
            const index = this.paReviewMeeting.reviewMeetingActionItems.findIndex((c) => c.id === actionItemId);
            if (index !== -1) {
                const updatedActionItem = {
                    ...this.paReviewMeeting.reviewMeetingActionItems[index],
                    isCompleted: !this.paReviewMeeting.reviewMeetingActionItems[index].isCompleted,
                };
                this.paReviewMeeting.reviewMeetingActionItems.splice(index, 1, updatedActionItem);
            }
        }
        RemoveActionItem(actionItemId) {
            const index = this.paReviewMeeting.reviewMeetingActionItems.findIndex((c) => c.id === actionItemId);
            if (index !== -1) {
                this.paReviewMeeting.reviewMeetingActionItems.splice(index, 1);
                this.paReviewMeeting = { ...this.paReviewMeeting, reviewMeetingActionItems: [...this.paReviewMeeting.reviewMeetingActionItems] };
            }
            this.paReviewMeeting.reviewMeetingActionItems = _.sortBy(this.paReviewMeeting.reviewMeetingActionItems, "dueDate");
        }
        SetMeetingDetail(paReviewMeetingDetail) {
            this.paReviewMeetingDetail = paReviewMeetingDetail;
        }
        SetMeetingClosed() {
            this.paReviewMeeting.isClosed = true;
            this.paReviewMeeting.reviewMeetingStatus = "Closed";
        }
        SetMeetingStarted(data) {
            if (this.paReviewMeeting.id == data.reviewMeetingId) {
                this.paReviewMeeting.isMeetingStarted = true;
                this.paReviewMeeting.reviewMeetingStatus = "Started";
                this.paReviewMeeting.reviewMeetingActualStartDate = data.reviewMeetingActualStartDate;
            }
        }
        SetMeetingEnded(data) {
            if (this.paReviewMeeting.id == data.reviewMeetingId) {
                this.paReviewMeeting.isMeetingEnded = true;
                this.paReviewMeeting.reviewMeetingStatus = "Ended";
                this.paReviewMeeting.reviewMeetingActualEndDate = data.reviewMeetingActualEndDate;
            }
        }
        AppendActionItem(actionItem) {
            var target = this.paReviewMeeting.reviewMeetingActionItems.findIndex((x) => x.id === actionItem.id);
            if (target !== -1) {
                this.paReviewMeeting.reviewMeetingActionItems[target] = actionItem;
            }
            else {
                this.paReviewMeeting.reviewMeetingActionItems.push(actionItem);
            }
            this.paReviewMeeting.reviewMeetingActionItems = _.sortBy(this.paReviewMeeting.reviewMeetingActionItems, "dueDate");
        }
        SetReviewMeetingDefaults(reviewMeetingParticipants) {
            this.reviewMeetingParticipants = reviewMeetingParticipants;
        }
        SetGoogleCalendar(isGoogleCalendarSynced) {
            this.isGoogleCalendarSynced = isGoogleCalendarSynced;
        }
        SetMeetingCreated(isMeetingCreated) {
            this.isMeetingCreated = isMeetingCreated;
        }
        SetReviewMeeting(paReviewMeeting) {
            this.paReviewMeeting = paReviewMeeting;
        }
        SetPAadminNudgeHistory(paAdminNudgeHistory) {
            this.paAdminNudgeHistory = paAdminNudgeHistory;
        }
        SetClientNudgeHistory(clientNudgeHistory) {
            this.clientNudgeHistory = clientNudgeHistory;
        }
        SetIsClientInterfacer(isClientInterfacer) {
            this.isClientInterfacer = isClientInterfacer;
        }
        SetIsReportingToManager(isReportingToManager) {
            this.isReportingToManager = isReportingToManager;
        }
        IsOpenedByClient() {
            this.openedByClient = true;
        }
        SetOperatingStepId(stepId) {
            this.operatingStepId = stepId;
        }
        PdfblobData(blob) {
            this.pdfData = blob;
        }
        setReviewId(id) {
            this.reviewId = id;
        }
        SetShowActionableFlag(showActionableItem) {
            this.showActionableItems = showActionableItem;
        }
        AssignParams(params) {
            this.gridParams = Object.assign({}, params);
        }
        AssignCycleDataParams(params) {
            this.gridParams.cycleFilters = Object.assign({}, params);
        }
        ResetPage() {
            this.gridParams = null;
        }
        ClearGridParams(params) {
            this.gridParams = params;
        }
        ClearReviewMeeting() {
            this.paReviewMeeting = null;
        }
        ClearReviewMeetingDetail() {
            this.paReviewMeetingDetail = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], PAReviewsModule.prototype, "GetReviewStepTabs", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetStepTabs", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IPAReviewSearchData !== "undefined" && IPAReviewSearchData) === "function" ? _b : Object]),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], PAReviewsModule.prototype, "GetReviews", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], PAReviewsModule.prototype, "GetCycleSummary", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof IPAReviewSearchData !== "undefined" && IPAReviewSearchData) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], PAReviewsModule.prototype, "GetReviewCycles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetCycleReviewsStatus", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetLegends", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetReviews", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetTeams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetYearList", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetTotalCount", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], PAReviewsModule.prototype, "GetReviewDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], PAReviewsModule.prototype, "GetReviewDetailByIdForDisplay", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], PAReviewsModule.prototype, "GetReviewDetailByIdForClient", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof PAReviewItemDetailModel !== "undefined" && PAReviewItemDetailModel) === "function" ? _k : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetReviewDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof PAReviewAnswerItemModel !== "undefined" && PAReviewAnswerItemModel) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], PAReviewsModule.prototype, "SaveReviewAnswers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof PAReviewAnswerItemModel !== "undefined" && PAReviewAnswerItemModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetAnswerText", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_p = typeof PAReviewCommentItemModel !== "undefined" && PAReviewCommentItemModel) === "function" ? _p : Object]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], PAReviewsModule.prototype, "SaveReviewComment", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_r = typeof Promise !== "undefined" && Promise) === "function" ? _r : Object)
    ], PAReviewsModule.prototype, "DeleteReviewComment", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_s = typeof IPAReviewCommentItemDTO !== "undefined" && IPAReviewCommentItemDTO) === "function" ? _s : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "setReviewComment", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_t = typeof IPAReviewCommentItemDTO !== "undefined" && IPAReviewCommentItemDTO) === "function" ? _t : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "setReviewClientComment", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_u = typeof Promise !== "undefined" && Promise) === "function" ? _u : Object)
    ], PAReviewsModule.prototype, "SubmitReview", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_v = typeof Promise !== "undefined" && Promise) === "function" ? _v : Object)
    ], PAReviewsModule.prototype, "DeliverReview", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_w = typeof IPAReviewRejectionReasonDTO !== "undefined" && IPAReviewRejectionReasonDTO) === "function" ? _w : Object]),
        __metadata("design:returntype", Promise)
    ], PAReviewsModule.prototype, "RejectReview", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_x = typeof Promise !== "undefined" && Promise) === "function" ? _x : Object)
    ], PAReviewsModule.prototype, "ClientInteractionDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_y = typeof Promise !== "undefined" && Promise) === "function" ? _y : Object)
    ], PAReviewsModule.prototype, "GetReviewExecutorDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_z = typeof IClientInteractionDetailsDTO !== "undefined" && IClientInteractionDetailsDTO) === "function" ? _z : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetClientInteractionDetails", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_0 = typeof IPACycleEmployeeReviewOverViewExecutorDTO !== "undefined" && IPACycleEmployeeReviewOverViewExecutorDTO) === "function" ? _0 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetReviewExecutorDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_1 = typeof Promise !== "undefined" && Promise) === "function" ? _1 : Object)
    ], PAReviewsModule.prototype, "GetCycleReviewDetailsForClient", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "setCycleReviewDetailsForClient", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], PAReviewsModule.prototype, "SaveClientAssignments", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_2 = typeof IClientContactAssignmentDTO !== "undefined" && IClientContactAssignmentDTO) === "function" ? _2 : Object]),
        __metadata("design:returntype", Promise)
    ], PAReviewsModule.prototype, "ClientNudgeEmail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_3 = typeof Promise !== "undefined" && Promise) === "function" ? _3 : Object)
    ], PAReviewsModule.prototype, "GeneratePAReviewPDF", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_4 = typeof Promise !== "undefined" && Promise) === "function" ? _4 : Object)
    ], PAReviewsModule.prototype, "UpdateAutoNudgeForClientContact", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_5 = typeof Promise !== "undefined" && Promise) === "function" ? _5 : Object)
    ], PAReviewsModule.prototype, "GettingNudgeHistory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_6 = typeof Promise !== "undefined" && Promise) === "function" ? _6 : Object)
    ], PAReviewsModule.prototype, "GettingPAAdminNudgeHistory", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_7 = typeof Promise !== "undefined" && Promise) === "function" ? _7 : Object)
    ], PAReviewsModule.prototype, "GetReviewMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_8 = typeof PAReviewScheduleMeetingModel !== "undefined" && PAReviewScheduleMeetingModel) === "function" ? _8 : Object]),
        __metadata("design:returntype", typeof (_9 = typeof Promise !== "undefined" && Promise) === "function" ? _9 : Object)
    ], PAReviewsModule.prototype, "saveMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_10 = typeof Promise !== "undefined" && Promise) === "function" ? _10 : Object)
    ], PAReviewsModule.prototype, "GetReviewMeetingDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_11 = typeof PAReviewMeetingActionItemModel !== "undefined" && PAReviewMeetingActionItemModel) === "function" ? _11 : Object]),
        __metadata("design:returntype", typeof (_12 = typeof Promise !== "undefined" && Promise) === "function" ? _12 : Object)
    ], PAReviewsModule.prototype, "addActionItem", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_13 = typeof PAReviewMeetingActionItemModel !== "undefined" && PAReviewMeetingActionItemModel) === "function" ? _13 : Object]),
        __metadata("design:returntype", typeof (_14 = typeof Promise !== "undefined" && Promise) === "function" ? _14 : Object)
    ], PAReviewsModule.prototype, "updateActionItem", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_15 = typeof Promise !== "undefined" && Promise) === "function" ? _15 : Object)
    ], PAReviewsModule.prototype, "StartReviewMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_16 = typeof Promise !== "undefined" && Promise) === "function" ? _16 : Object)
    ], PAReviewsModule.prototype, "EndReviewMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_17 = typeof Promise !== "undefined" && Promise) === "function" ? _17 : Object)
    ], PAReviewsModule.prototype, "closeReviewMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_18 = typeof Promise !== "undefined" && Promise) === "function" ? _18 : Object)
    ], PAReviewsModule.prototype, "deleteReviewMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_19 = typeof Promise !== "undefined" && Promise) === "function" ? _19 : Object)
    ], PAReviewsModule.prototype, "editMeetingDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_20 = typeof PAReviewScheduleMeetingModel !== "undefined" && PAReviewScheduleMeetingModel) === "function" ? _20 : Object]),
        __metadata("design:returntype", typeof (_21 = typeof Promise !== "undefined" && Promise) === "function" ? _21 : Object)
    ], PAReviewsModule.prototype, "updateMeeting", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_22 = typeof Promise !== "undefined" && Promise) === "function" ? _22 : Object)
    ], PAReviewsModule.prototype, "completeActionItem", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_23 = typeof Promise !== "undefined" && Promise) === "function" ? _23 : Object)
    ], PAReviewsModule.prototype, "deleteActionItem", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_24 = typeof IGuidItem !== "undefined" && IGuidItem) === "function" ? _24 : Object]),
        __metadata("design:returntype", typeof (_25 = typeof Promise !== "undefined" && Promise) === "function" ? _25 : Object)
    ], PAReviewsModule.prototype, "upsertNotes", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_26 = typeof IGuidItem !== "undefined" && IGuidItem) === "function" ? _26 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "UpdateNotes", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "CompleteActionItem", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "RemoveActionItem", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_27 = typeof PAReviewScheduleMeetingModel !== "undefined" && PAReviewScheduleMeetingModel) === "function" ? _27 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetMeetingDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetMeetingClosed", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetMeetingStarted", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetMeetingEnded", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_28 = typeof PAReviewMeetingActionItemModel !== "undefined" && PAReviewMeetingActionItemModel) === "function" ? _28 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "AppendActionItem", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetReviewMeetingDefaults", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetGoogleCalendar", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetMeetingCreated", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_29 = typeof PAReviewMeetingModel !== "undefined" && PAReviewMeetingModel) === "function" ? _29 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetReviewMeeting", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetPAadminNudgeHistory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetClientNudgeHistory", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetIsClientInterfacer", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetIsReportingToManager", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "IsOpenedByClient", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetOperatingStepId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "PdfblobData", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "setReviewId", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "SetShowActionableFlag", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_30 = typeof IPAReviewSearchData !== "undefined" && IPAReviewSearchData) === "function" ? _30 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "AssignParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_31 = typeof PACycleRequestModel !== "undefined" && PACycleRequestModel) === "function" ? _31 : Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "AssignCycleDataParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "ResetPage", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "ClearGridParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "ClearReviewMeeting", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PAReviewsModule.prototype, "ClearReviewMeetingDetail", null);
    PAReviewsModule = __decorate([
        Module({ dynamic: true, store: store, name: "paReview", namespaced: true })
    ], PAReviewsModule);
    return PAReviewsModule;
})();
export const PAReviewModule = getModule(PAReviewsModule);
